export default [
  {
    path: "/products",
    name: "products",
    meta: { title: "Products", authRequired: true },
    component: () => import("../views/apps/ecommerce/products"),
  },
  {
    path: "/product-details/:id?",
    name: "product-details",
    meta: { title: "Product Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/product-details"),
  },
  {
    path: "/product-update/:id?",
    name: "product-update",
    meta: { title: "Product Update", authRequired: true },
    component: () => import("../views/apps/ecommerce/update-product"),
  },
];
